import { Modal } from "antd";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import changeConfirmationDialog from "../../../../components/ChangeConfirmationDialog";
import Datepicker from "../../../../components/Datepicker";
import NotesComponent from "../../../../components/NotesComponent";
import ExamStatusEnum from "../../../../logic/ExamStatusEnum";
import { examStatusToString } from "../../../../logic/utilsClinical.js";
import { xhrClinicalGetExamStudyByExamId } from "../../../../utilities/xhr-clinical";
import { xhrTenantGetDoctorsByInstitutionIds } from "../../../../utilities/xhr-tenant";
import { UpdateUserPreferences } from "../../../../redux/actions/account-action-types";
import {
	formattedDate,
	formattedDateTime,
	formattedAge,
} from "../../../../utilities/dateFormatter";
import DocumentViewer from "../../../../components/DocumentViewer";
import ReportViewer from "../../../../components/ReportViewer";
import translator from "../../../../utilities/translator";

import AreaBookmark from "../../../../components/AreaBookmark";
import { xhrApiGetToken } from "../../../../utilities/xhr-api";
import toastUtil from "../../../../utilities/toast-util";

export default function ReviewInfoClinica({
	institution,
	mainExam,
	bundledExams,
	associatedReport,
	patHistoryExams,
	patientDetails,
	compareStudies,
	setCompareStudies,
	showImages,
}) {
	const dispatch = useDispatch();
	const token = useSelector((state) => state.session.token);

	const userInfo = useSelector((state) => state.session.userInfo);
	const userPermissions = useSelector((state) => state.session.userPermissions);
	const userPreferences = useSelector(
		(state) => state?.session?.userPreferences
	);
	const currentLanguage = userPreferences?.language;

	const [showDocumentsModal, setShowDocumentsModal] = React.useState(false);
	const [documentsModalExams, setDocumentsModalExams] = React.useState([]);
	const [showReportViewModal, setShowReportViewModal] = React.useState(null);

	const [compareExams, setCompareExams] = React.useState([]);
	const [processing, setProcessing] = React.useState(false);

	const [doctorList, setDoctorList] = React.useState(null);
	const hoverRef = useRef(null);
	React.useEffect(() => {
		let mountedRef = true;
		if (mainExam?.instId) {
			const effectPromise = async () => {
				var data = await xhrTenantGetDoctorsByInstitutionIds(token, [
					mainExam?.instId,
				]);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				if (data?.result?.data?.length > 0) {
					setDoctorList(
						data?.result?.data
							?.map((x) => x.user)
							.sort((a, b) => (a.userDisplayName < b.userDisplayName ? -1 : 1))
					);
				}
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [mainExam, token]);

	const [doctorId, setDoctorId] = React.useState(
		mainExam?.reportUsrId ? mainExam.reportUsrId : ""
	);

	const [technicianId, setTechnicianId] = React.useState(
		mainExam?.tecUsrId ? mainExam.tecUsrId : ""
	);

	const toggleImagesPopup = React.useCallback(
		async (x, newWindow, download) => {
			let exam_id = x.id;
			if (!newWindow && !download && compareExams.includes(x.id)) {
				setCompareExams([]);
				setCompareStudies([]);
			} else {
				setProcessing(true);
				var data = await xhrClinicalGetExamStudyByExamId(token, exam_id);
				toastUtil({ currentLanguage, data });
				setTimeout(() => {
					setProcessing(false);
				}, 5000);

				let ExamStudyByExamId = data?.result?.data;
				if (!ExamStudyByExamId?.length) {
					return;
				}
				const records = ExamStudyByExamId?.map((x) => x.studyUid);

				if (download) {
					var data2 = await xhrApiGetToken(token, mainExam?.tenantId);
					toastUtil({ currentLanguage, data: data2 });
					var dataToken = data2?.result?.data;

					records.forEach((record) => {
						document.dispatchEvent(
							new CustomEvent("medapp_image_download", {
								bubbles: true,
								detail: {
									uri:
										"https://wado.centro2s.com/api/Studies/" +
										record +
										"/DownloadStudy",
									token: dataToken,
									name:
										x?.patIdent +
										"_" +
										x?.productName +
										"_" +
										formattedDate(x?.planDatetime),
								},
							})
						);
					});
				} else if (records?.length > 0) {
					if (newWindow === true) {
						var data2 = await xhrApiGetToken(token, mainExam?.tenantId);
						toastUtil({ currentLanguage, data: data2 });
						var dataToken = data2?.result?.data;

						let url = ``;
						url = `${
							process.env.REACT_APP_VIEWER_OHIF_URL
						}?StudyInstanceUIDs=${records.join(
							"&StudyInstanceUIDs="
						)}&hangingProtocolId=@ohif/mnGrid&token=${dataToken}`;
						window.open(url);
					} else {
						let compare2 = [];
						compare2.push(x.id);
						setCompareExams(compare2);
						setCompareStudies((x) => records);
					}
				}
			}
		},
		[compareStudies, compareExams, token, mainExam, currentLanguage]
	);

	const canShowImages = true;

	if (!mainExam || !patientDetails) {
		return <div></div>;
	}

	return (
		<ul
			className="dropdown-menu toolbar-design w-100 p-0 m-0 box-shadow"
			// aria-labelledby="imgtop-toolbar1"
			style={{ display: "block", overflow: "hidden" }}
		>
			<li className="dropdown-submenu">
				<div className="dropdown-item dropdown-toggle p-0">
					<AreaBookmark
						active={userPreferences?.examEditorClinicalInfoOpen ?? false}
						onChange={async (e) => {
							dispatch(
								UpdateUserPreferences({
									data: {
										examEditorClinicalInfoOpen:
											!userPreferences?.examEditorClinicalInfoOpen,
									},
									callback: () => {},
								})
							);
						}}
					/>

					<div
						className="container-fluid drop-body "
						style={{ maxHeight: "73vh", overflow: "scroll" }}
					>
						<form className="w-100 row">
							<div
								className="col-lg-6 col-md-6 col-sm-12 cusborder-right py-3"
								style={{ paddingRight: "1em", display: "block" }}
							>
								<div className="drop-bodyinner">
									<div
										style={{
											border: "1px solid #ccc",
											borderRadius: "8px",
											padding: "12px",
											marginBottom: "16px",
										}}
									>
										<h3
											style={{
												marginTop: 0,
												borderBottom: "1px solid #eee",
												paddingBottom: "6px",
											}}
										>
											<h4 className="heading-droptoolbar m-0 p-0">
												{translator(currentLanguage, "relClinicalNotes")}
											</h4>
										</h3>
										<NotesComponent
											mainExam={mainExam}
											bundledExams={bundledExams}
										/>
									</div>
									<div style={{ display: "flex", gap: "16px" }}>
										<div
											style={{
												flex: 1,
												border: "1px solid #ccc",
												borderRadius: "8px",
												padding: "12px",
											}}
										>
											<table
												style={{
													tableLayout: "fixed",
													width: "100%",
													lineHeight: "1.7em",
													borderCollapse: "collapse",
												}}
											>
												<tbody>
													{/* Grupo: Paciente */}
													<tr>
														<td
															colSpan={2}
															style={{
																background: "#f5f5f5",
																fontWeight: "bold",
																padding: "6px",
															}}
														>
															{translator(
																currentLanguage,
																"patientclinicainfo"
															)}
														</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "pat_id")}
														</td>
														<td>{mainExam?.patId}</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "pat_ident")}
														</td>
														<td>{mainExam?.patIdent}</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "pat_name")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
															}}
														>
															{`${mainExam?.patFirstName} ${mainExam?.patMiddleName} ${mainExam?.patLastName}`}
														</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "dob")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															{formattedDate(mainExam?.patDob)} -{" "}
															{formattedAge(mainExam?.patDob)}
														</td>
													</tr>

													{/* Grupo: Exame */}
													<tr>
														<td
															colSpan={2}
															style={{
																background: "#f5f5f5",
																fontWeight: "bold",
																padding: "6px",
															}}
														>
															{translator(currentLanguage, "examclinicainfo")}
														</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "institution")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															{institution?.name}
														</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "entity")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															{mainExam?.refEntName}
														</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "clinical_area")}
														</td>
														<td>{mainExam?.departmentCode}</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "exam_description")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															{mainExam?.productName?.length > 50
																? mainExam?.productName.substring(0, 49) + "…"
																: mainExam?.productName}
														</td>
													</tr>

													{/* Grupo: Identificadores */}
													<tr>
														<td
															colSpan={2}
															style={{
																background: "#f5f5f5",
																fontWeight: "bold",
																padding: "6px",
															}}
														>
															{translator(
																currentLanguage,
																"examclinicainfoidentifiers"
															)}
														</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "request_id")}
														</td>
														<td>{mainExam?.requestId}</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "acn")}
														</td>
														<td>{mainExam?.acn}</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "eid")}
														</td>
														<td>{mainExam?.id}</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "rid")}
														</td>
														<td>{mainExam?.reportId}</td>
													</tr>
												</tbody>
											</table>
										</div>

										<div
											style={{
												flex: 1,
												border: "1px solid #ccc",
												borderRadius: "8px",
												padding: "12px",
											}}
										>
											<table
												style={{
													tableLayout: "fixed",
													width: "100%",
													lineHeight: "1.7em",
													borderCollapse: "collapse",
												}}
											>
												<tbody>
													{/* Technician */}
													<tr>
														<td
															colSpan={2}
															style={{
																background: "#f5f5f5",
																fontWeight: "bold",
																padding: "6px",
															}}
														>
															{translator(
																currentLanguage,
																"examclinicainfoproperty"
															)}
														</td>
													</tr>
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "technician")}
														</td>
														<td style={{ maxWidth: "100%" }}>
															<span
																title={mainExam?.tecUsrName}
																style={{
																	display: "inline-block",
																	maxWidth: "100%",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "middle",
																}}
															></span>
														</td>
													</tr>

													{/* Radiologist */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "radiologist")}
														</td>
														<td style={{ maxWidth: "100%" }}>
															<span
																title={mainExam?.reportUsrName}
																style={{
																	display: "inline-block",
																	maxWidth: "100%",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																	verticalAlign: "middle",
																}}
															>
																{mainExam?.reportUsrName}
															</span>
														</td>
													</tr>

													{/* Referring Doctor */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "referring_doctor")}
														</td>
														<td>
															<span title={mainExam?.reqUsrName}>
																{mainExam?.reqUsrName}
															</span>
														</td>
													</tr>
													<tr>
														<td
															colSpan={2}
															style={{
																background: "#f5f5f5",
																fontWeight: "bold",
																padding: "6px",
															}}
														>
															{translator(
																currentLanguage,
																"examclinicainfoidates"
															)}
														</td>
													</tr>
													{/* Delivery Date */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "delivery_date")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															<span title={mainExam?.deliveryDate}>
																{formattedDateTime(mainExam?.deliveryDate)}
															</span>
														</td>
													</tr>

													{/* Admission Date */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "admission_date")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															<span title={mainExam?.planDatetime}>
																{formattedDateTime(mainExam?.planDatetime)}
															</span>
														</td>
													</tr>

													{/* Perform Date */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "perform_date")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															<span title={mainExam?.endDatetime}>
																{formattedDateTime(mainExam?.endDatetime)}
															</span>
														</td>
													</tr>

													{/* Report Date */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "report_date")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															<span title={mainExam?.reportDt}>
																<span title={mainExam?.reportDt}>
																	{formattedDateTime(
																		associatedReport?.reportDt
																	)}
																</span>
															</span>
														</td>
													</tr>

													{/* Transcription Date */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(
																currentLanguage,
																"transcription_date"
															)}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															<span title={mainExam?.transcDt}>
																{formattedDateTime(associatedReport?.transcDt)}
															</span>
														</td>
													</tr>

													{/* Validation Date */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "validation_date")}
														</td>
														<td
															style={{
																wordBreak: "break-word", // quebra em qualquer ponto
																overflowWrap: "anywhere", // força quebra se for preciso
																whiteSpace: "normal", // permite várias linhas
																textTransform: "uppercase",
															}}
														>
															<span title={mainExam?.signDt}>
																{formattedDateTime(associatedReport?.signDt)}
															</span>
														</td>
													</tr>

													<tr>
														<td
															colSpan={2}
															style={{
																background: "#f5f5f5",
																fontWeight: "bold",
																padding: "6px",
															}}
														>
															{translator(
																currentLanguage,
																"examclinicainforeportinfo"
															)}
														</td>
													</tr>
													{/* Addendum */}
													<tr>
														<td className="titleCol titleColIC">
															{translator(currentLanguage, "addendum")}
														</td>
														<td>
															<span>
																{translator(
																	currentLanguage,
												associatedReport?.isAddendum
																		? "yes"
																		: "no"
																)}
															</span>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
							<div
								className="col-lg-6 col-md-6 col-sm-12"
								style={{ paddingLeft: "1em" }}
							>
								<div className="drop-bodyinner">
									<div className="border-radius-4">
										<Modal
											open={showDocumentsModal}
											title="Documents"
											onOk={() => setShowDocumentsModal(false)}
											onCancel={() => setShowDocumentsModal(false)}
											zIndex={5000}
											className="custom-modal matching-modal headerborder-0 modal-width modal-dialog"
											width="1000px"
										>
											<DocumentViewer
												bundledExams={documentsModalExams}
												readOnly={true}
											/>
										</Modal>
										<Modal
											open={showReportViewModal > 0}
											title="Report"
											onOk={() => setShowReportViewModal(null)}
											onCancel={() => setShowReportViewModal(null)}
											zIndex={5000}
											className="custom-modal matching-modal headerborder-0 modal-width modal-dialog"
											width="1000px"
										>
											<div style={{ height: "70vh" }}>
												<ReportViewer reportId={showReportViewModal} />
											</div>
										</Modal>

										<table
											className="table fav-list-table modern-datatable"
											style={{ width: "100%", borderCollapse: "collapse" }}
										>
											<thead>
												<tr>
													<th
														style={{
															textAlign: "center",
															borderBottom: "2px solid #dee2e6",
															padding: "8px",
															cursor: "pointer",
														}}
														title={translator(currentLanguage, "status")}
													>
														{translator(currentLanguage, "statusinit")}
													</th>
													<th
														style={{
															textAlign: "left",
															borderBottom: "2px solid #dee2e6",
															padding: "8px",
														}}
														title={`${translator(
															currentLanguage,
															"modality"
														)} - ${translator(currentLanguage, "exam")}`}
													>
														{`${translator(
															currentLanguage,
															"modalityinit"
														)} - ${translator(currentLanguage, "examinit")}`}
													</th>

													<th
														style={{
															textAlign: "center",
															borderBottom: "2px solid #dee2e6",
															padding: "8px",
														}}
														title={translator(currentLanguage, "request")}
													>
														{translator(currentLanguage, "requestinit")}
													</th>
													<th
														style={{
															textAlign: "center",
															borderBottom: "2px solid #dee2e6",
															padding: "8px",
														}}
														title={translator(currentLanguage, "images")}
													>
														{translator(currentLanguage, "imagesinit")}
													</th>
													<th
														style={{
															textAlign: "center",
															borderBottom: "2px solid #dee2e6",
															padding: "8px",
														}}
														title={translator(currentLanguage, "report")}
													>
														{translator(currentLanguage, "reportinit")}
													</th>
												</tr>
											</thead>
											<tbody>
												<>
													{patHistoryExams?.length ? (
														patHistoryExams
															.sort((a, b) => {
																return (
																	new Date(b.planDatetime) -
																	new Date(a.planDatetime)
																);
															})
															?.map((x, i) => (
																<tr
																	className={
																		i % 2 === 0 ? "row-even" : "row-odd"
																	} // para linhas alternadas
																	style={{
																		position: "relative",
																		borderRadius: "2px",
																		backgroundColor:
																			mainExam?.id === x?.id
																				? "rgba(59, 143, 59, 0.1)"
																				: "transparent", // destaque para mainExam
																		cursor: "pointer",
																	}}
																	key={`item-${i}`}
																>
																	{/* Coluna Status */}
																	<td
																		style={{
																			textAlign: "center",
																			padding: "8px",
																			position: "relative",
																		}}
																	>
																		{x?.active === false && (
																			<i
																				title={examStatusToString(
																					currentLanguage,
																					x
																				)}
																				className="zmdi zmdi-block active"
																				style={{
																					fontSize: "2.1em", // 🔹 bem menor que o ícone base
																					color: "red",
																					position: "absolute",
																					borderRadius: "50%", // 🔹 bolinha
																					padding: "2px", // 🔹 espaço interno
																				}}
																			></i>
																		)}

																		{x.status === ExamStatusEnum.PLANNED && (
																			<i
																				title={examStatusToString(
																					currentLanguage,
																					x
																				)}
																				className="zmdi zmdi-calendar-note active"
																				style={{ fontSize: "2.5em" }}
																			></i>
																		)}

																		{x.status === ExamStatusEnum.STARTED && (
																			<i
																				title={examStatusToString(
																					currentLanguage,
																					x
																				)}
																				className="zmdi zmdi-time-restore active"
																				style={{ fontSize: "2.5em" }}
																			></i>
																		)}

																		{x.status === ExamStatusEnum.REPORT && (
																			<i
																				title={examStatusToString(
																					currentLanguage,
																					x
																				)}
																				className="zmdi zmdi-book-image active"
																				style={{ fontSize: "2.5em" }}
																			></i>
																		)}

																		{/* TRANSCRIPTION */}
																		{x.status ===
																			ExamStatusEnum.TRANSCRIPTION && (
																			<span
																				title={examStatusToString(
																					currentLanguage,
																					x
																				)}
																				className="zmdi-hc-stack"
																				style={{
																					fontSize: "2.5em", // controlo único de tamanho

																					display: "inline-block",
																					verticalAlign: "middle",
																				}}
																			>
																				<i
																					className="zmdi zmdi-file zmdi-hc-stack-2x active"
																					style={{ fontSize: "1em" }}
																				/>
																				<i
																					className="zmdi zmdi-volume-up zmdi-hc-stack-1x"
																					style={{ fontSize: "1em" }}
																				/>
																			</span>
																		)}

																		{x.status === ExamStatusEnum.TO_SIGN && (
																			<i
																				title={examStatusToString(
																					currentLanguage,
																					x
																				)}
																				className="zmdi zmdi-file active"
																				style={{ fontSize: "2.5em" }}
																			></i>
																		)}

																		{x.status === ExamStatusEnum.SIGNED && (
																			<span
																				title={examStatusToString(
																					currentLanguage,
																					x
																				)}
																				className="zmdi-hc-stack zmdi-hc-lg"
																				style={{ fontSize: "2.5em" }} // tamanho do stack inteiro
																			>
																				<i
																					className="zmdi zmdi-file zmdi-hc-stack-2x active"
																					style={{ fontSize: "1em" }}
																				></i>
																				<i
																					className="zmdi zmdi-check zmdi-hc-stack-1x"
																					style={{ fontSize: "1em" }}
																				></i>
																			</span>
																		)}
																	</td>

																	{/* Coluna Exame */}
																	<td
																		style={{
																			textAlign: "left",
																			padding: "5px",
																		}}
																	>
																		<h3
																			className="font-roboto"
																			style={{
																				margin: 0,
																				textTransform: "uppercase",

																				wordBreak: "break-word", // quebra em qualquer ponto
																				overflowWrap: "anywhere", // força quebra se for preciso
																				whiteSpace: "normal", // permite várias linhas
																			}}
																		>
																			{x.tecAreaCode} - {x.productName}
																			{/* {x.productName?.length > 50
																				? x.productName.substring(0, 49) + "…"
																				: x.productName} */}
																		</h3>
																		<h4
																			className="font-roboto"
																			style={{
																				margin: 0,
																				fontSize: "1em",
																				color: "#6c757d",
																			}}
																		>
																			{translator(currentLanguage, "acn")}:{" "}
																			{x.acn} |{" "}
																			{translator(currentLanguage, "date")}:{" "}
																			{formattedDateTime(x.planDatetime)} |{" "}
																			{translator(currentLanguage, "rid")}:{" "}
																			{x.reportId}
																		</h4>
																	</td>

																	{/* Coluna Pedido / Documentos */}
																	<td
																		style={{
																			textAlign: "center",
																			width: "20px",
																		}}
																	>
																		{
																			<button
																				disabled={processing}
																				onClick={(e) => {
																					e.preventDefault();
																					e.stopPropagation();
																					if (processing) return;
																					setDocumentsModalExams(
																						bundledExams?.findIndex(
																							(y) => y.id === x.id
																						) > -1
																							? bundledExams
																							: [x]
																					);
																					setShowDocumentsModal(true);
																				}}
																				title={translator(
																					currentLanguage,
																					"open_request"
																				)}
																				style={{
																					background: "#ffffff",
																					border: "2px solid #e78e4b",
																					borderRadius: "8px",
																					padding: "8px 12px",
																					cursor: processing
																						? "not-allowed"
																						: "pointer",
																					display: "inline-flex",
																					alignItems: "center",
																					justifyContent: "center",
																					transition: "all 0.2s",
																					outline: "none",
																					boxShadow:
																						"0 4px 6px rgba(0,0,0,0.15)",
																					opacity: processing ? 0.5 : 1,
																				}}
																				onMouseOver={(e) => {
																					e.currentTarget.style.background =
																						"#EBB994"; // hover mais vivo
																					e.currentTarget.style.boxShadow =
																						"0 6px 10px rgba(0,0,0,0.2)";
																					e.currentTarget.style.transform =
																						"translateY(-2px)";
																				}}
																				onMouseOut={(e) => {
																					e.currentTarget.style.background =
																						"#fff";
																					e.currentTarget.style.boxShadow =
																						"0 4px 6px rgba(0,0,0,0.15)";
																					e.currentTarget.style.transform =
																						"translateY(0)";
																				}}
																				onMouseDown={(e) => {
																					e.currentTarget.style.transform =
																						"translateY(1px) scale(0.95)";
																					e.currentTarget.style.boxShadow =
																						"0 2px 4px rgba(0,0,0,0.1)";
																				}}
																				onMouseUp={(e) => {
																					e.currentTarget.style.transform =
																						"translateY(-2px) scale(1)";
																					e.currentTarget.style.boxShadow =
																						"0 6px 10px rgba(0,0,0,0.2)";
																				}}
																			>
																				<i
																					className="zmdi zmdi-attachment-alt zmdi-hc-2x"
																					style={{
																						fontSize: "2em",
																						color: "#05585E",
																					}}
																				/>
																			</button>
																		}
																	</td>
																	{/* Coluna Imagens */}
																	<td
																		style={{
																			textAlign: "center",
																			width: "20px",
																		}}
																	>
																		{x.hasImages && (
																			<div className="hoverTopArea">
																				<div
																					title="Open Images"
																					className="exam-prop-icon"
																					style={{
																						textAlign: "center",
																						display: "none",
																						float: "left",
																						minHeight: "35px",
																						minWidth: "35px",
																						marginRight: "1px",
																						background: compareExams.includes(
																							x.id
																						)
																							? "lightgreen"
																							: "#ffffff",
																						opacity: processing ? "0.5" : "1",
																						border: "2px solid #e78e4b",
																						borderRadius: "8px",
																						padding: "8px 12px",
																						cursor: processing
																							? "not-allowed"
																							: "pointer",
																						transition: "all 0.2s",
																						outline: "none",
																						boxShadow:
																							"0 4px 6px rgba(0,0,0,0.15)",

																						padding: "8px 12px",
																						display: "inline-flex",
																						alignItems: "center",
																						justifyContent: "center",
																					}}
																					onMouseOver={(e) => {
																						e.currentTarget.style.background =
																							"#EBB994"; // hover mais vivo
																						e.currentTarget.style.boxShadow =
																							"0 6px 10px rgba(0,0,0,0.2)";
																						e.currentTarget.style.transform =
																							"translateY(-2px)";
																					}}
																					onMouseOut={(e) => {
																						e.currentTarget.style.background =
																							"#fff";
																						e.currentTarget.style.boxShadow =
																							"0 4px 6px rgba(0,0,0,0.15)";
																						e.currentTarget.style.transform =
																							"translateY(0)";
																					}}
																					onMouseDown={(e) => {
																						e.currentTarget.style.transform =
																							"translateY(1px) scale(0.95)";
																						e.currentTarget.style.boxShadow =
																							"0 2px 4px rgba(0,0,0,0.1)";
																					}}
																					onMouseUp={(e) => {
																						e.currentTarget.style.transform =
																							"translateY(-2px) scale(1)";
																						e.currentTarget.style.boxShadow =
																							"0 6px 10px rgba(0,0,0,0.2)";
																					}}
																					disabled={processing}
																				>
																					<div
																						style={{
																							overflow: "hidden",
																						}}
																						onClick={async (e) => {
																							e.preventDefault();
																							e.stopPropagation();

																							if (processing) return;
																							await toggleImagesPopup(x);
																						}}
																					>
																						<i
																							className="zmdi zmdi-image-o"
																							style={{
																								fontSize: "2em",
																								color: "#05585E",
																							}}
																						/>
																					</div>
																				</div>

																				<div
																					className="hoverTopPanel"
																					style={{
																						position: "absolute",
																						top: "44px",
																						left: "0",
																						background: "#fff",
																						zIndex: "1",
																						width: "45px",
																						textAlign: "center",
																					}}
																				>
																					<div
																						title="Download Images"
																						className={
																							x.hasImages
																								? "exam-prop-icon"
																								: ""
																						}
																						style={{
																							display: "none",
																							float: "left",
																							background: "#fff",
																							minHeight: "35px",
																							minWidth: "35px",
																							opacity: processing ? "0.5" : "1",
																							border: "2px solid #e78e4b",
																							borderRadius: "8px",
																							cursor: processing
																								? "not-allowed"
																								: "pointer",
																							transition: "all 0.2s",
																							outline: "none",
																							boxShadow:
																								"0 4px 6px rgba(0,0,0,0.15)",
																							textAlign: "center",
																							alignItems: "center",
																							justifyContent: "center",
																							padding: "8px 12px",
																							display: "inline-flex",
																						}}
																						onMouseOver={(e) => {
																							e.currentTarget.style.background =
																								"#EBB994"; // hover mais vivo
																							e.currentTarget.style.boxShadow =
																								"0 6px 10px rgba(0,0,0,0.2)";
																							e.currentTarget.style.transform =
																								"translateY(-2px)";
																						}}
																						onMouseOut={(e) => {
																							e.currentTarget.style.background =
																								"#fff";
																							e.currentTarget.style.boxShadow =
																								"0 4px 6px rgba(0,0,0,0.15)";
																							e.currentTarget.style.transform =
																								"translateY(0)";
																						}}
																						onMouseDown={(e) => {
																							e.currentTarget.style.transform =
																								"translateY(1px) scale(0.95)";
																							e.currentTarget.style.boxShadow =
																								"0 2px 4px rgba(0,0,0,0.1)";
																						}}
																						onMouseUp={(e) => {
																							e.currentTarget.style.transform =
																								"translateY(-2px) scale(1)";
																							e.currentTarget.style.boxShadow =
																								"0 6px 10px rgba(0,0,0,0.2)";
																						}}
																						disabled={processing}
																					>
																						<div
																							style={{
																								overflow: "hidden",
																							}}
																							onClick={async (e) => {
																								e.preventDefault();
																								e.stopPropagation();

																								if (processing) return;
																								await toggleImagesPopup(
																									x,
																									false,
																									true
																								);
																							}}
																						>
																							<i
																								className="zmdi zmdi-download"
																								style={{
																									fontSize: "2em",
																									color: "#05585E",
																								}}
																							/>
																						</div>
																					</div>

																					<div
																						title="Open Images External Window"
																						className={
																							x.hasImages
																								? "exam-prop-icon"
																								: ""
																						}
																						style={{
																							display: "none",
																							float: "left",
																							minHeight: "35px",
																							minWidth: "35px",
																							marginRight: "1px",
																							opacity: processing ? "0.5" : "1",
																							border: "2px solid #e78e4b",
																							borderRadius: "8px",
																							cursor: processing
																								? "not-allowed"
																								: "pointer",
																							transition: "all 0.2s",
																							outline: "none",
																							boxShadow:
																								"0 4px 6px rgba(0,0,0,0.15)",

																							background: "#ffffff",
																							padding: "8px 12px",

																							display: "inline-flex",
																							alignItems: "center",
																							justifyContent: "center",
																						}}
																						onMouseOver={(e) => {
																							e.currentTarget.style.background =
																								"#EBB994"; // hover mais vivo
																							e.currentTarget.style.boxShadow =
																								"0 6px 10px rgba(0,0,0,0.2)";
																							e.currentTarget.style.transform =
																								"translateY(-2px)";
																						}}
																						onMouseOut={(e) => {
																							e.currentTarget.style.background =
																								"#fff";
																							e.currentTarget.style.boxShadow =
																								"0 4px 6px rgba(0,0,0,0.15)";
																							e.currentTarget.style.transform =
																								"translateY(0)";
																						}}
																						onMouseDown={(e) => {
																							e.currentTarget.style.transform =
																								"translateY(1px) scale(0.95)";
																							e.currentTarget.style.boxShadow =
																								"0 2px 4px rgba(0,0,0,0.1)";
																						}}
																						onMouseUp={(e) => {
																							e.currentTarget.style.transform =
																								"translateY(-2px) scale(1)";
																							e.currentTarget.style.boxShadow =
																								"0 6px 10px rgba(0,0,0,0.2)";
																						}}
																						disabled={processing}
																					>
																						<div
																							style={{
																								overflow: "hidden",
																							}}
																							onClick={async (e) => {
																								e.preventDefault();
																								e.stopPropagation();

																								if (processing) return;
																								await toggleImagesPopup(
																									x,
																									true
																								);
																							}}
																						>
																							<i
																								className="zmdi zmdi-arrows"
																								style={{
																									color: "#05585E",
																									fontSize: "1.5em", // seta menor para não “sair” do stack
																								}}
																							/>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}
																	</td>
																	{/* Coluna Relatório */}
																	<td
																		style={{
																			textAlign: "center",
																			width: "20px",
																		}}
																	>
																		{x.reportId &&
																			x.status === ExamStatusEnum.SIGNED && (
																				<button
																					disabled={processing}
																					onClick={(e) => {
																						e.preventDefault();
																						e.stopPropagation();
																						if (processing) return;
																						setShowReportViewModal(x.reportId);
																					}}
																					title={translator(
																						currentLanguage,
																						"view_report"
																					)}
																					style={{
																						background: "#ffffff",
																						border: "2px solid #e78e4b",
																						borderRadius: "8px",
																						padding: "8px 12px",
																						cursor: processing
																							? "not-allowed"
																							: "pointer",
																						display: "inline-flex",
																						alignItems: "center",
																						justifyContent: "center",
																						transition: "all 0.2s",
																						outline: "none",
																						boxShadow:
																							"0 4px 6px rgba(0,0,0,0.15)",
																						opacity: processing ? 0.5 : 1,
																					}}
																					onMouseOver={(e) => {
																						e.currentTarget.style.background =
																							"#EBB994"; // hover mais vivo
																						e.currentTarget.style.boxShadow =
																							"0 6px 10px rgba(0,0,0,0.2)";
																						e.currentTarget.style.transform =
																							"translateY(-2px)";
																					}}
																					onMouseOut={(e) => {
																						e.currentTarget.style.background =
																							"#fff";
																						e.currentTarget.style.boxShadow =
																							"0 4px 6px rgba(0,0,0,0.15)";
																						e.currentTarget.style.transform =
																							"translateY(0)";
																					}}
																					onMouseDown={(e) => {
																						e.currentTarget.style.transform =
																							"translateY(1px) scale(0.95)";
																						e.currentTarget.style.boxShadow =
																							"0 2px 4px rgba(0,0,0,0.1)";
																					}}
																					onMouseUp={(e) => {
																						e.currentTarget.style.transform =
																							"translateY(-2px) scale(1)";
																						e.currentTarget.style.boxShadow =
																							"0 6px 10px rgba(0,0,0,0.2)";
																					}}
																				>
																					<i
																						className="zmdi zmdi-file"
																						style={{
																							fontSize: "2em",
																							color: "#05585E",
																						}}
																					/>
																				</button>
																			)}
																	</td>
																</tr>
															))
													) : (
														<tr className="form-group check-design m-0">
															<td colSpan={5} className="text-center">
																{translator(currentLanguage, "exams")}:
															</td>
														</tr>
													)}
												</>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</li>
		</ul>
	);
}
